import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { AfterContentChecked, Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { GenericValue } from '../../../core/model/generic-value';
import { AutoComplete } from 'primeng/autocomplete';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
            <p-autoComplete #content
                [hisDdKey]="options.ddKey"
                [formControl]="formControl"
                [hisEagerDataSource]="options.typeAheadUrl"
                [dropdown]="true"
                [forceSelection]="true"
                field="defaulttext">
            </p-autoComplete>
        </his-plam>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class KeytableSelectComponent extends HisDynamicFieldBase<string> implements OnInit, AfterContentChecked {
    @ViewChild( 'content' ) autoComplete: AutoComplete;
    selectedGenericValue: GenericValue;
    genericValueTypes: GenericValue[];
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    ngOnInit() {
        super.initFormControl( this.selectedGenericValue );
    }

    ngAfterContentChecked() {
        if( ( this.autoComplete && this.autoComplete._suggestions ) && this.genericValueTypes == null ) {
            if( this.autoComplete._suggestions ) {
                this.genericValueTypes = this.autoComplete._suggestions();
                if ( this.genericValueTypes && this.options.defaultValue ) {
                    this.selectedGenericValue = this.genericValueTypes.find(
                        genericValue => {
                            if ( genericValue.id === Number.parseFloat( this.value ) ) {
                                return genericValue;
                            }
                            return undefined;
                        } );
                    this.formControl.setValue( this.selectedGenericValue, { emitEvent: false } );
                    this.defaultValue = this.selectedGenericValue;
                }
            }
        }
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        console.log( 'search config' );
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        console.log( 'found: ' + matchingConfig );
        if ( matchingConfig !== null ) {
            if ( this.genericValueTypes ) {
                let selectedGenericValue: GenericValue = this.genericValueTypes.find( genericValue =>
                    Number.parseFloat( matchingConfig.defaultValue ) === genericValue.id
                ) || null;
                this.formControl.setValue( selectedGenericValue, { emitEvent: false } );
            }
        }
    }

    getControlValue(): any {
        return this.formControl.value ? ( '' + this.formControl.value.id ) : '';
    }
}
